import { NgModule } from "@angular/core";

import { CodeEditorModule } from "@acrodata/code-editor";

import { TextEditorsCoreModule } from "../text-editors-core.module";
import { CssEditorComponent } from "./components/css-editor.component";
import { CssEditorLanguageService } from "./services/css-editor-language.service";


@NgModule({
    declarations: [
        CssEditorComponent
    ],
    providers: [
        CssEditorLanguageService,
    ],
    exports: [
        CssEditorComponent,
    ],
    imports: [
        TextEditorsCoreModule,
        CodeEditorModule,
    ]
})
export class CssEditorModule {
}